import { render, staticRenderFns } from "./Calls.vue?vue&type=template&id=74f129d7&scoped=true"
import script from "./Calls.vue?vue&type=script&lang=js"
export * from "./Calls.vue?vue&type=script&lang=js"
import style0 from "./Calls.vue?vue&type=style&index=0&id=74f129d7&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "74f129d7",
  null
  
)

export default component.exports